<template>
  <div class="g-container-p">
    <div class="m-container-p">
      <!-- 面包屑 -->
      <div class="crumbs-box-p">
        <span>匠心记</span>
        <span>&gt;</span>
        <span>{{titleText}}</span>
      </div>
      <div class="carate-report-main-p">
        <h2 class="create-report-tit-p">{{titleText}}</h2>
        <div class="report-name-p" v-if="type == 'report'">
          <input type="text" placeholder="请输入检测报告名" v-model="reportData.DetName" />
        </div>
        <div class="report-num-p" v-if="type == 'report'">
          <input type="text" placeholder="请输入检测报告编号" v-model="reportData.DetId" />
        </div>
        <image-upload
          :src="src"
          :isPic="true"
          :picImgs="picDataArr"
          :thumPicImgs="thumPicDataArr"
          @getDataArr="getDataArr"
          @getDataArrPic="getDataArrPic"

        >
          <i slot="del" class="del-p"></i>
        </image-upload>
        <div class="report-btn-p" v-if="type == 'report'">
          <p @click="uploadReprot">上传</p>
          <p @click="reload">上传并继续</p>
        </div>
        <div class="report-btn-p1" v-if="type == 'warranty'">
          <p @click="uploadWarranty">确定</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../../../../html/pages/originality/createTestReport/createTestReport.scss"

import imageUpload from "../../../../components/imageUpload/ImageUpload"

import { getJxjDetail, SetProjectLogDetectionInfo, SetProjectLogJointWarranty } from "../../../../api/index"

export default {
  name: 'createTestReport',
  data() {
    return {
      src1: require("../../../../html/pages/originality/createTestReport/images/upload1.png"),
      src2: require("../../../../html/pages/originality/createTestReport/images/upload2.png"),
      reportData: {
        id: this.$route.params.id,
        DetName: "",
        DetId: "",
        ImgUrl: []
      },
      picDataArr: [],//原图
      thumPicDataArr: [],//压缩图
      titleText: "",
      type: "",
      JointWarranty: [],//验收单
    }
  },
  components: {
    imageUpload
  },
  computed: {
    src() {
      if (this.type == "report") return this.src1
      if (this.type == "warranty") return this.src2
    }
  },
  methods: {
    getDataArr(data) {
      this.thumPicDataArr = data
    },
    getDataArrPic(data) {
      this.picDataArr = data
    },
    // 上传检测报告
    async uploadReprot(fn) {
      this.reportData.DetName = this.reportData.DetName.trim()
      this.reportData.DetId = this.reportData.DetId.trim()
      if (!this.reportData.DetName) {
        return this.$layer.alert("请输入检测报告名")
      }
      if (this.picDataArr.length == 0) {
        return this.$layer.alert("请上传图片")
      }
      this.reportData.ImgUrl = []
      this.picDataArr.forEach((item, i) => {
        this.reportData.ImgUrl.push({ pic: item, thumpic: this.thumPicDataArr[i] })
      })
      this.reportData.ImgUrl = this.reportData.ImgUrl.filter(function(a) { return a != null });
      this.reportData.ImgUrl = JSON.stringify(this.reportData.ImgUrl)
      let res = await SetProjectLogDetectionInfo(this.reportData)
      if (res.Type == "Success") {
        this.$layer.msg(res.Content, (msg) => {
          this.$layer.close(msg)
          if (typeof fn == "function") {
            fn()
          } else {
            this.$router.push({ name: "jxjDetail", params: { id: this.$route.params.id } })
          }
        })
      }
    },
    reload() {
      this.uploadReprot(item => {
        window.location.reload()
      })
    },
    // 上传验收单
    async uploadWarranty() {
      this.picDataArr.forEach((item, i) => {
        this.JointWarranty.push({ pic: item, thumpic: this.thumPicDataArr[i] })
      })
      this.JointWarranty = this.JointWarranty.filter(function(a) { return a != null });
      this.JointWarranty = JSON.stringify(this.JointWarranty)
      let res = await SetProjectLogJointWarranty({
        id: this.$route.params.id,
        JointWarranty: this.JointWarranty
      })
      if (res.Type == "Success") {
        this.$layer.msg(res.Content, (msg) => {
          this.$layer.close(msg)
          this.$router.push({ name: "jxjDetail", params: { id: this.$route.params.id } })
        })
      }
    },
    init() {
      this.type = this.$route.query.type
      if (this.type == "report") {
        this.titleText = "创建检查报告"
      } else if (this.type == "warranty") {
        this.titleText = "创建验收单"
      }
    },
    async getJxjDetail() {
      let res = await getJxjDetail({
        id: this.$route.params.id
      })
      if (res.Type == "Success") {
        if(res.Data.jointWarranty != null){
          JSON.parse(res.Data.jointWarranty).forEach(item => {
            this.picDataArr.push(item.pic)
            this.thumPicDataArr.push(item.thumpic)
          })
        }
      }
    }
  },
  created() {
    this.init()
    if (this.type == "warranty") {
      this.getJxjDetail()
    }
  },
  beforeRouteUpdate(to, from, next) {
    next();
    this.init();
    this.picDataArr = []
    this.thumPicDataArr = []
    if (this.type == "warranty") {
      this.getJxjDetail()
    }
  },
}
</script>

<style scoped>
</style>
